export const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL;
export const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_KEY;
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL as string;
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY as string;
